export enum DocumentType {
  BLUE_PRINT = 'bluePrint',
  CUSTOMER_MANUAL = 'customerManual',
  DESCRIPTIVE_MEMORIAL = 'descriptiveMemorial',
  ENTERPRISE_IMPLEMENTATION = 'enterpriseImplementation',
}

export enum VisitorStatusType {
  confirmed = 'confirmed',
  waitingList = 'waitingList',
  sorted = 'sorted',
  preDraw = 'preDraw',
}

export enum VisitEventStatusType {
  draft = 'draft',
  open = 'open',
  sorted = 'sorted',
  closed = 'closed',
}

export interface CustomDropdownItem {
  id: string
  text: string
}
